import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { createFormsNode } from './forms/index.ts';
import { createSalesCompNode } from './salesComp.ts';
import { createDirtyNode } from './utils.ts';

export const generateTotalXmlReport = (
  reportJSON: ReportJSON,
  formType: FormType,
  includeAnnotations: boolean,
): string => {
  const doc = document.implementation.createDocument('', '', null);
  const pi = doc.createProcessingInstruction('xml', 'version="1.0"');
  doc.insertBefore(pi, doc.firstChild);

  const report = createReportNode(doc, formType);
  doc.appendChild(report);

  const forms = createFormsNode(doc, reportJSON, formType);
  report.appendChild(forms);

  const salesComp = createSalesCompNode(doc, reportJSON, formType, includeAnnotations);
  report.appendChild(salesComp);

  const serializer = new XMLSerializer();
  const reportString = serializer.serializeToString(doc);

  return reportString;
};

function createReportNode(doc: XMLDocument, formType: FormType): HTMLElement {
  const report = createDirtyNode(doc, 'REPORT');
  report.setAttribute('VERSION', '1.30');
  report.setAttribute('SOURCE', 'Appraisify Toolkit');
  report.setAttribute('SOURCEVERSION', '1.0');
  report.setAttribute('FILENUM', '');
  report.setAttribute('DESCRIPTION', '');

  report.setAttribute('MAJORFORM', getMajorFormCode(formType));

  return report;
}

function getMajorFormCode(formType: FormType): string {
  switch (formType) {
    case FormType.fnma1004:
      return '1004UAD';
    case FormType.fnma2055:
      return '2055UAD';
    case FormType.fnma1004c:
      return '1004C';
    case FormType.fnma1025:
      return '1025';
    case FormType.gpResidential:
      return 'GPRES2';
    default:
      throw new Error(`Unsupported form type: ${formType as FormType}`);
  }
}
